const cache = new Map<string, HTMLImageElement | "loading" | "error">();
let onLoad: () => void = () => {};
export const setImageListener = (f: () => void) => (onLoad = f);

export function img(src: string | undefined): HTMLImageElement | null {
  if (!src) return null;
  const c = cache.get(src);
  if (c instanceof HTMLImageElement) return c;
  if (c) return null;
  cache.set(src, "loading");
  const im = new Image();
  im.decoding = "async";
  im.onload = () => { cache.set(src, im); onLoad(); };
  im.onerror = () => cache.set(src, "error");
  im.src = src;
  return null;
}

// ---- status markers ----
export const COLOR_MARKERS: Record<string, string> = {
  red: "#e33", blue: "#36f", green: "#2b2", brown: "#963", purple: "#93c", pink: "#f6c", yellow: "#ec0",
};
export const MARKERS: Record<string, string> = {
  dead: "💀", blinded: "🙈", charmed: "💘", deafened: "🙉", frightened: "😱", grappled: "✊", incapacitated: "💫",
  invisible: "👻", paralyzed: "⚡", petrified: "🗿", poisoned: "🤢", prone: "🛌", restrained: "⛓️", stunned: "😵",
  unconscious: "💤", exhaustion: "🥱", concentrating: "🧠", blessed: "✨", burning: "🔥", bleeding: "🩸", flying: "🕊️",
  hasted: "💨", hidden: "👤", raging: "😡", inspired: "🎵", shielded: "🛡️", marked: "🎯", cursed: "☠️", frozen: "❄️",
};
export const ALL_MARKERS = [...Object.keys(COLOR_MARKERS), ...Object.keys(MARKERS)];

// ---- procedural playing cards ----
const cardCache = new Map<string, HTMLCanvasElement>();
export function cardFace(name: string): HTMLCanvasElement {
  const key = "f" + name;
  let c = cardCache.get(key);
  if (c) return c;
  c = document.createElement("canvas");
  c.width = 200; c.height = 280;
  const g = c.getContext("2d")!;
  roundRect(g, 2, 2, 196, 276, 14);
  g.fillStyle = "#fffdf7"; g.fill();
  g.strokeStyle = "#333"; g.lineWidth = 3; g.stroke();
  const red = /[♥♦]/.test(name);
  g.fillStyle = name === "Joker" ? "#6a2c91" : red ? "#c1121f" : "#111";
  if (name === "Joker") {
    g.font = "bold 40px serif"; g.textAlign = "center"; g.fillText("JOKER", 100, 150); g.font = "70px serif"; g.fillText("🃏", 100, 230);
  } else {
    const suit = name.slice(-1), rank = name.slice(0, -1);
    g.font = "bold 36px serif"; g.textAlign = "left"; g.fillText(rank, 14, 44);
    g.font = "30px serif"; g.fillText(suit, 14, 76);
    g.save(); g.translate(186, 236); g.rotate(Math.PI); g.font = "bold 36px serif"; g.fillText(rank, 0, 0); g.restore();
    g.font = "110px serif"; g.textAlign = "center"; g.fillText(suit, 100, 180);
  }
  cardCache.set(key, c);
  return c;
}
export function cardBack(): HTMLCanvasElement {
  let c = cardCache.get("back");
  if (c) return c;
  c = document.createElement("canvas");
  c.width = 200; c.height = 280;
  const g = c.getContext("2d")!;
  roundRect(g, 2, 2, 196, 276, 14);
  g.fillStyle = "#7a1c1c"; g.fill();
  g.strokeStyle = "#f3d9a4"; g.lineWidth = 6; g.stroke();
  g.save(); g.clip();
  g.strokeStyle = "rgba(243,217,164,0.35)"; g.lineWidth = 2;
  for (let i = -300; i < 300; i += 16) { g.beginPath(); g.moveTo(i, 0); g.lineTo(i + 280, 280); g.stroke(); g.beginPath(); g.moveTo(i + 280, 0); g.lineTo(i, 280); g.stroke(); }
  g.restore();
  g.fillStyle = "#f3d9a4"; g.font = "bold 60px serif"; g.textAlign = "center"; g.fillText("✦", 100, 160);
  cardCache.set("back", c);
  return c;
}
export function roundRect(g: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  g.beginPath();
  g.moveTo(x + r, y);
  g.arcTo(x + w, y, x + w, y + h, r);
  g.arcTo(x + w, y + h, x, y + h, r);
  g.arcTo(x, y + h, x, y, r);
  g.arcTo(x, y, x + w, y, r);
  g.closePath();
}
